<template>
  <div class="container" id="container">
    <div class="header DIN-Bold">
      <h2>Terms of Service</h2>
    </div>
    <div class="box SFUITEXT-REGULAR">
      <p>
        These terms apply to the Applications for mobile devices that were created by Guangzhou Shishan Technology Co., Ltd. (hereby referred to as "Service Provider").
        <br>Upon downloading or utilizing the Applications, you are automatically agreeing to the following terms. It is strongly advised that you thoroughly read and understand these terms before using the Application.
      </p>
      <h2>1. ACTIVATION</h2>
      <p>
        For certain Services, you must agree to the Terms of Service and you may need to allow the App to access some of your device’s features and information on your device. For example, we may need:
        <br>- Device information
        <br>- Device and application History
        <br>- Wi-Fi connections
      </p>
      <h2>2. GOOGLE PLAY STORE</h2>
      <p>
        This is an agreement between you and Service Provider but your license is conditioned upon your compliance with the terms and conditions of any agreement that you may have with a Third Party App Store, such as Google Play Store. If any part of your agreement with a Third Party App Store contradicts a part of the Terms of Service, or is less restrictive than the Terms of Service, you are bound by the more restrictive agreement.
      </p>
      <h3>3. THIRD PARTY SITES</h3>
      <p>
        The service may include links to websites operated by others, which we call “Third Party Sites.” Clicking on those links may allow users to visit the websites and applications of third parties. Service Provider accepts no responsibility or liability regarding these Third Party Sites, as we do not review all of the material made available at those sites. We do not promise, warrant, represent, or imply that we endorse any material, product, service, or opinion on a Third Party Site. Third-party websites have their terms of service, privacy policies, regulations, and practices, which you should review before accessing a third-party website through a link.
      </p>
      <h2>4. YOUR CONDUCT</h2>
      <p>
        By installing the App, you are making clear statements that you will not use the App or website in violation of any applicable laws or regulations. While using the Services, users shall not interfere with, damage or disrupt any part of our Services;
        <br>Transmit or upload viruses and harmful programs;
        <br>Reproduce, duplicate or sell any part of our Services;
        <br>And Infringe the intellectual property rights and legitimate interests of any person.
        <br><br>
        <br>Please note that the service provider does not assume responsibility for certain aspects. Some features of the App require an active internet connection, either Wi-Fi or provided by your mobile network provider. The service provider is not responsible if the app does not run at full capacity due to lack of access to Wi-Fi or if your data allowance has been exhausted.
        <br>If you use the App outside a Wi-Fi zone, please note that your mobile network provider's terms of agreement still apply. As a result, you may be charged fees by your mobile provider or other third-party charges for data usage while connected to the App. By using the App, you accept responsibility for any such charges, including roaming data charges if you use the App outside your home territory (i.e. region or country) without disabling data roaming. If you are not the bill payer of the device using the app, they will assume you have the bill payer's permission.
      </p>
      <h2>5. UPDATE</h2>
      <p>
        In terms of the Service Provider's responsibility for your use of the application, it is important to note that while they strive to ensure that it is updated and accurate at all times, they do rely on third parties to provide information to them so that they can make it available to you. The Service Provider accepts no liability for any loss, direct or indirect, that you experience as a result of relying entirely on this functionality of the application.
        <br><br>
        The Service Provider may wish to update the application at some point. The application is currently available as per the requirements for the operating system (and for any additional systems they decide to extend the availability of the application to) may change, and you will need to download the updates if you want to continue using the application. The Service Provider does not guarantee that it will always update the application so that it is relevant to you and/or compatible with the particular operating system version installed on your device. However, you agree to always accept updates to the application when offered to you. The Service Provider may also wish to cease providing the application and may terminate its use at any time without providing termination notice to you. Unless they inform you otherwise, upon any termination, (a) the rights and licenses granted to you in these terms will end; (b) you must cease using the application, and (if necessary) delete it from your device.
      </p>
      <h2>6. Changes to These Terms and Conditions</h2>
      <p>
        The Service Provider may periodically update their Terms and Conditions. Therefore, you are advised to review this page regularly for any changes. The Service Provider will notify you of any changes by posting the new Terms and Conditions on this page.
        <br><br>
        These terms and conditions are effective as of 2024-04-08
      </p>
      <h2>7. Contact Us</h2>
      <p>
        If you have any questions or suggestions about the Terms and Conditions, please do not hesitate to contact the Service Provider at shbraingames@outlook.com.
      </p>
    </div>
    <div class="footer">
      <div class="footer_menu">
        <a @click="toPage('/home')">Home</a>
        <a @click="toPage('/privacy.html')">Privacy Policy</a>
        <a @click="toPage('/terms.html')">Terms of Service</a>
      </div>
      <p>Copyright © 2024.Guangzhou Shishan Technology Co., Ltd. All rights reserved.</p>
    </div>
  </div>
</template>

<script>
export default {
    name:"termsPage",
    mounted(){
      document.getElementById('container').scrollIntoView({ behavior: 'smooth' });
    },
    methods:{
      // 跳转页面
      toPage(path){
        
        this.$router.push({ 'path': path }).catch((err)=>{console.log(err);});
        window.removeEventListener('scroll', this.getScrollHeight)
      },
    }
}
</script>

<style lang="scss" scoped>
.box{
  width: 80%;
  margin: 50px auto;
  max-width: 1350px;
  min-width: 400px;
  text-align: justify;
  padding: 0 20px;
  h2{
    margin: 50px 0 30px;
  }
}
.header{
  height: 120px;
  background-color: #000;
  color: #fff;
  line-height: 120px;
}
.footer{
    width: 100%;
    background-color: #000;
    height: 120px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    .footer_menu{
      font-family: "SFUITEXT-REGULAR";
      width: 400px;
      display: flex;
      justify-content: space-evenly;
      a{
        cursor: pointer;
        font-size: 18px;
        color: #B0E0FC;}
    }
    p{
      font-size: 21px;
      color: #fff;
    }
  }
</style>